const StoreTemp = {
  set: function (key, data) {
    sessionStorage.removeItem(key);
    sessionStorage.setItem(key, JSON.stringify(data));
  },
  get: function (key) {
    const data = sessionStorage.getItem(key);
    sessionStorage.removeItem(key);
    return JSON.parse(data);
  },
};

export default StoreTemp;
